<div class="flex flex-row w-full h-[72px] shadow-full">
  @if (!pressedX) {
    <div class="flex flex-row w-full h-full px-5 py-3 border-t-1 border-grey-200 justify-between items-center">
      <!-- Title and text -->
      <div class="flex flex-col w-2/3 h-full justify-start items-start">
        <p class="text-gray font-semibold text-[16px]">{{ title }}</p>
        <p class="text-gray-500 text-[14px]">{{ descr }}</p>
      </div>
      <!-- Buttons and 'dont show' -->
      <div class="flex flex-row w-1/3 h-full justify-end items-center gap-6">
        <div (click)="routeTo()"
             class="flex flex-row w-hug h-[38px] px-3 py-2 gap-2 border border-grey-300 rounded-lg justify-between items-center hover:cursor-pointer">
          <p class="text-gray font-medium text-[14px]">{{ buttonText() }}</p>
          <fa-icon [icon]="faChevronRight" class="text-gray text-[16px]"></fa-icon>
        </div>
        <!--        <div *ngIF="unsubscriber" class="flex flex-row"></div>-->
        <fa-icon (click)="pressX()" [icon]="faXmark"
                 class="text-gray-500 text-[16px] hover:cursor-pointer"></fa-icon>
      </div>
    </div>
  }
</div>
